import styled from "styled-components";

type CopyWrapperProps = {
  $disabled: string
}

type CopiedTooltipProps = {
  $position?: 'left' | 'right';
}

export const CopyWrapper = styled.div<CopyWrapperProps>`
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  ${props => props.$disabled=='true' && `
    opacity: 0.5;
    pointer-events: none;
  `}
`

export const CopiedTooltip = styled.div<CopiedTooltipProps>`
  position: absolute;
  background: rgba(161, 170, 198, 1);
  border-radius: 24px;
  color: #fff;
  padding: 4px;
  ${props => {
    const pos = props.$position || 'right';
    if (pos === 'right') {
      return 'right: -80px;'
    } else {
      return `
        left: -80px;
      `
    }
  }}
  
  font-size: 10px;
`